import { TemplateModel } from '@/components/ui';
import { FORMATTER_CLASSIFICATION_FUNCTION_ID } from '@/constants';
import { generateId } from '@/utils';

import {
  currencyFormatter,
  dateFormatter,
  highConfidenceValidator,
  ibanFormatter,
  numericFormatter,
} from './common.ts';

export const GENERIC: TemplateModel = {
  fields: [
    {
      id: generateId(),
      type: 'single-value',
      name: 'Text',
      validators: [highConfidenceValidator],
      helpProps: {
        defaultName: undefined,
        namePlaceholder: 'My field name',
        promptHintPlaceholder: 'Short description of the field',
      },
    },
    {
      id: generateId(),
      type: 'single-value',
      name: 'Numeric',
      formatters: [numericFormatter],
      validators: [highConfidenceValidator],
      helpProps: {
        defaultName: undefined,
        namePlaceholder: 'My field name',
        promptHintPlaceholder: 'Short description of the field',
      },
    },
    {
      id: generateId(),
      type: 'single-value',
      name: 'Date',
      formatters: [dateFormatter],
      validators: [highConfidenceValidator],
      helpProps: {
        defaultName: undefined,
        namePlaceholder: 'My date field',
        promptHintPlaceholder: 'A short description of the field',
      },
    },
    {
      id: generateId(),
      type: 'single-value',
      name: 'Currency',
      formatters: [currencyFormatter],
      validators: [highConfidenceValidator],
      helpProps: {
        defaultName: 'Currency',
        namePlaceholder: 'Currency',
        promptHintPlaceholder: 'The currency',
      },
    },
    {
      id: generateId(),
      type: 'single-value',
      name: 'Classification',
      formatters: [
        {
          functionId: FORMATTER_CLASSIFICATION_FUNCTION_ID,
          name: 'Classification',
          description: 'Enforce one of the defined classes',
          config: {
            labels: [],
          },
        },
      ],
      validators: [highConfidenceValidator],
      helpProps: {
        defaultName: undefined,
        namePlaceholder: 'Document type or line item cost type',
        promptHintPlaceholder: 'The type of document',
      },
    },
    {
      id: generateId(),
      type: 'single-value',
      name: 'IBAN',
      formatters: [ibanFormatter],
      validators: [highConfidenceValidator],
      comingSoon: true,
    },
  ],
  sampleDocuments: [],
};
